import type { Locale } from '@/basket/types/locale';

export const API_ENDPOINTS: {
  BASE: string;
  REVIEWS: string;
} = {
  BASE: process.env.NEXT_PUBLIC_API_BASE_URL || '',
  REVIEWS: process.env.NEXT_PUBLIC_API_REVIEWS_URL || '',
};

export const axiosDefaultHeaders = (locale: Locale) => ({
  'Content-Type': 'application/json',
  Accept: 'application/json',
  'Accept-Language': locale,
});
